import commonConfig from '../../common.config';

export default {
    state: {
        path: [],
        user: false,
        tag_map: {},
        albums: [],
        teams: [],
        route_back_to: "",
        nameRules: [
            v => !!v || 'Name is required',
            v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        current_album: null,
        current_sheet: null,
        // is_add_score: false,
        newed_album: null,
        current_score: null,
        instruments: [
            'violin',
            'viola',
            'cello',
            'piano'
        ],
        share_scopes: [
            'private',
            'team',
            'organization',
            'public'
        ],
        loading: false,
        currentMusicXML: null,
        breadcrumbs: [

        ] //{text: string, disabled: boolean, href: 'admin'}
    },
    getters: {
        pagePath: state => {
            return state.path;
        },
        routeBackTo: state => {
            return state.route_back_to;
        },
        userInfo: state => {
            return state.user;
        },
        nameRules: state => {
            return state.nameRules;
        },
        instruments: state => {
            return state.instruments;
        },
        shareScopes: state => {
            return state.share_scopes;
        },
        userUuid: state => {
            return state.user.uuid;
        },
        tagMap: state => {
            return state.tag_map;
        },
        albums: state => {
            return state.albums;
        },
        teams: state => {
            return state.teams;
        },
        currentAlbum: state => {
            return state.current_album;
        },
        newedAlbum: state => {
            return state.newed_album;
        },
        currentSheet: state => {
            return state.current_sheet;
        },
        currentScore: state => {
            return state.current_score;
        },
        isLoading: state => {
            return state.loading;
        },
        currentMusicXML: state => {
            return state.currentMusicXML;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        }
    },
    mutations: {
        toPage: function (state, payload) {
            const routerName = payload.router_name;
            const routerArray = [];
            if (traverseMenu(routerArray, routerName, commonConfig.menu_config)) {
                state.path = routerArray;
            }
        },
        rememberUser: function(state, payload) {
            // window.sessionStorage.setItem(`user`,JSON.stringify(payload.user));
            state.user = payload.user;
        },
        setRouteBackTo: function(state, payload) {
            state.route_back_to = payload.route_back_to;
        },
        forgetUser: function(state) {
            state.user = false;
        },
        saveTagMap: function(state, payload) {
            state.tag_map = payload.tag_map;
        },
        setAlbums: function(state, payload) {
            state.albums = payload.albums;
        },
        setNewedAlbum: function(state, payload) {
            state.newed_album = payload.album;
            if (!state.newed_album) return;
            const index = state.albums.findIndex(album => album.uuid == payload.album.uuid);
            if (index >= 0) {
                state.albums[index] = state.newed_album;
            } else {
                state.albums.push(state.newed_album)
            }
        },
        setCurrentAlbum: function(state, payload) {
            state.current_album = payload.album;
            if (!state.current_album) return;
            const index = state.albums.findIndex(album => album.uuid == payload.album.uuid);
            if (index >= 0) {
                state.albums[index] = state.current_album;
            } else {
                state.albums.push(state.current_album)
            }
        },
        setCurrentScore: function(state, payload) {
            state.current_score = payload.score;
        },
        setCurrentSheet: function(state, payload) {
            state.current_sheet= payload.sheet;
        },
        setLoading: function(state, payload) {
            state.loading = payload.is_loading;
        },
        setBreadcrumbs: function(state, payload) {
            state.breadcrumbs = payload.breadcrumbs;
        },
        setCurrentMusicXML: function(state, payload) {
            state.currentMusicXML = payload.currentMusicXML;
        }
    }
};


function traverseMenu(pathArray, routerName, menuNode) {
    pathArray.push({
        router_name: menuNode.router_name,
        display_name: menuNode.display_name
    });
    if (menuNode.router_name === routerName) return true;
    if (menuNode.sub_menus) {
        for (const key of menuNode.sub_menus) {
            if (traverseMenu(pathArray, routerName, key)) {
                return true;
            }
        }
    }
    pathArray.pop();
    return false;
}
